<mat-dialog-content>
    <div style="display: flex;
                justify-content: space-between;
                background: grey;
                padding: 5px;
                border-radius: 10px;">
        <div style="font-weight: bold;
                    color: white;
                    top: 10px;
                    left: 10px;
                    position: relative;">
            {{mailType == 'quote' ? 'Review Quote Email' :
            mailType == 'share_report' ? 'Share Report' :
            mailType == 'releaseOrder' ? 'Share Release Order' :
            mailType == 'returnOrder' ? 'Share Return Order' :
            'Booking Confirmed Email'}}
        </div>
        <div>
            <button mat-icon-button mat-dialog-close style="color: white; background: transparent;">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <div>
        <div style="display: flex;
                    align-items: center;
                    gap: 10px;">
            <span style="font-weight: bold">To:</span>
            <mat-form-field>
                <div [formGroup]="sendEmailForm">
                    <input type="text" placeholder="Select or add users" matInput formControlName="chipCtrl"
                        [matAutocomplete]="auto" (keyup.enter)="addNewChip()" (click)="showAllOptions()"
                        [ngClass]="{'error': submitted && myForm.chipCtrl.errors}" style="font-weight: bold">
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                        <mat-option *ngFor="let option of filteredOptions" [value]="option">
                            {{ option }}
                        </mat-option>
                    </mat-autocomplete>
                    <!-- <div class="invalid-feedback" *ngIf="submitted && myForm.chipCtrl.errors?.required">
                    <sup>*</sup>Please enter your email
                </div> -->
                </div>
            </mat-form-field>
        </div>
        <ul class="errorList" *ngIf="submitted && myForm.chipCtrl.errors?.pattern">
            <li>Please enter valid email</li>
        </ul>
        <mat-chip-list #chipList>
            <mat-chip *ngFor="let chip of chips" [selectable]="selectable" [removable]="removable"
                (removed)="remove(chip)">
                {{ chip }}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip>
        </mat-chip-list>
    </div>
    <div style="display: flex;
                align-items: center;
                gap: 10px;">
        <span style="font-weight: bold">Subject:</span>
        <mat-form-field>
            <input type="text" matInput [(ngModel)]="subject" style="font-weight: bold">
        </mat-form-field>
    </div>
    <div>
        <div [innerHTML]="content"></div>
        <quill-view [content]="content" format="html" theme="snow"
            style="max-width: 761px; min-height: 100px; overflow: auto;"></quill-view>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div style="width: 100%;
                display: flex;
                justify-content: flex-end;">
        <button mat-raised-button class="Save" [disabled]="disableSave" (click)="sendConfirmationEmail()"
            [disabled]="chips.length == 0">
            <span *ngIf="!disableSave">
                Send Email
            </span>
            <div *ngIf="disableSave" class="p03">
                <i class="flaticon-loading spin"></i>
                <span>Sending Email...</span>
            </div>
        </button>
    </div>
</mat-dialog-actions>